
export const navItems = [
    {
      id: 1,
      title: "About Us ⮟",
      path: "./aboutus",
      cName: "nav-item",
    },
    {
      id: 2,
      title: "Admission ⮟",
      path: "./admission",
      cName: "nav-item",
    },
    {
      id: 3,
      title: "Acadamic ⮟",
      path: "./acadamic",
      cName: "nav-item",
    },
    {
      id: 4,
      title: "Services ⮟",
      path: "./services",
      cName: "nav-item",
    },
    {
      id: 5,
      title: "Feedback ⮟",
      path: "./feedback",
      cName: "nav-item",
    },
    {
      id: 6,
      title: "QuickLinks ⮟",
      path: "./quicklinks",
      cName: "nav-item",
    },
  ];

  
  export const aboutDropdown = [
    {
      id: 1,
      title: "MEASI",
      path: "/measi",
      cName: "submenu-item",
    },
    {
      id: 2,
      title: "The New College",
      path: "/the new college",
      cName: "submenu-item",
    },
    {
      id: 3,
      title: "Administration",
      path: "/adminstration",
      cName: "submenu-item",
    },
    {
      id: 4,
      title: "Autonomy",
      path: "/autonomy",
      cName: "submenu-item",
    },
    {
      id: 5,
      title: "NAAC",
      path: "/naac",
      cName: "submenu-item",
    },
    {
      id: 6,
      title: "NIRF",
      path: "/nirfa",
      cName: "submenu-item",
    },
    {
      id: 7,
      title: "AISHE",
      path: "/aishe",
      cName: "submenu-item",
    },
    {
      id: 8,
      title: "Code of Conduct",
      path: "/codeofconduct",
      cName: "submenu-item",
    },
  ];
  

  export const admissionDropdown = [
    {
      id: 1,
      title: "General Instruction",
      path: "/generalinstruction",
      cName: "submenu-item",
    },
    {
      id: 2,
      title: "Fee Structure",
      path: "/Fee Structure",
      cName: "submenu-item",
    },
    {
      id: 3,
      title: "Rules & Regulations",
      path: "/Rules & Regulations",
      cName: "submenu-item",
    },
    {
      id: 4,
      title: "Admission Policy",
      path: "/Admission Policy",
      cName: "submenu-item",
    },
    {
      id: 5,
      title: "Admission Committee",
      path: "/Admission Committee",
      cName: "submenu-item",
    },
    {
      id: 6,
      title: "Online Applications",
      path: "/Online Applications",
      cName: "submenu-item",
    },
  ];

  export const acadamicDropdown = [
    {
      id: 1,
      title: "Departments",
      path: "/Departments",
      cName: "submenu-item",
    },
    {
      id: 2,
      title: "Faculty",
      path: "/Faculty",
      cName: "submenu-item",
    },
    {
      id: 3,
      title: "Administrative Staff",
      path: "/Administrative Staff",
      cName: "submenu-item",
    },
    {
      id: 4,
      title: "Programmes",
      path: "/Programmes",
      cName: "submenu-item",
    },
    {
      id: 5,
      title: "Syllabus",
      path: "/Syllabus",
      cName: "submenu-item",
    },
    {
      id: 6,
      title: "Programme Outcomes",
      path: "/Programme Outcomes",
      cName: "submenu-item",
    },
    {
      id: 7,
      title: "Physical Education",
      path: "/Physical Education",
      cName: "submenu-item",
    },
    {
      id: 8,
      title: "Academic Calender",
      path: "/Academic Calender",
      cName: "submenu-item",
    },
  ];

  export const servicesDropdown = [
    {
      id: 1,
      title: "Placement Cell",
      path: "/Placement Cell",
      cName: "submenu-item",
    },
    {
      id: 2,
      title: "Scholarship",
      path: "/Scholarship",
      cName: "submenu-item",
    },
    {
      id: 3,
      title: "Capacity Development",
      path: "/Capacity Development",
      cName: "submenu-item",
    },
    {
      id: 4,
      title: "Students Union",
      path: "/Students Union",
      cName: "submenu-item",
    },
    {
      id: 5,
      title: "Grievance / Request",
      path: "/Grievance / Request",
      cName: "submenu-item",
    },
    {
      id: 6,
      title: "Staff Association",
      path: "/Staff Association",
      cName: "submenu-item",
    },
    {
      id: 7,
      title: "IIEC",
      path: "/IIEC",
      cName: "submenu-item",
    },
  ];


  export const feedbackDropdown = [
    {
      id: 1,
      title: "Employee",
      path: "/Employee",
      cName: "submenu-item",
    },
    {
      id: 2,
      title: "Parents",
      path: "/Parents",
      cName: "submenu-item",
    },
    {
      id: 3,
      title: "Students",
      path: "/Students",
      cName: "submenu-item",
    },
    {
      id: 4,
      title: "Alumni",
      path: "/Alumni",
      cName: "submenu-item",
    },
  ];


  export const quicklinksDropdown = [
    {
      id: 1,
      title: "Student / Faculty Login",
      path: "/SFlogin",
      cName: "submenu-item",
    },
    {
      id: 2,
      title: "Online Payment",
      path: "/onlinepayment",
      cName: "submenu-item",
    },
    {
      id: 3,
      title: "Library",
      path: "/Library",
      cName: "submenu-item",
    },
    {
      id: 4,
      title: "Education Verification",
      path: "/everification",
      cName: "submenu-item",
    },
    {
      id: 5,
      title: "Grievance",
      path: "/Grievance",
      cName: "submenu-item",
    },
    {
      id: 6,
      title: "Download",
      path: "/download",
      cName: "submenu-item",
    },
    {
      id: 7,
      title: "Scholarships and Fellowships",
      path: "/Scholarships and Fellowships",
      cName: "submenu-item",
    },
    {
      id: 8 ,
      title: "Attendance Report",
      path: "/Attendance Report",
      cName: "submenu-item",
    },
  ];